'use strict'

const { alertMessage } = require('cisalfa/common/common');

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    let options = $productContainer
        .find('.product-option')
        .map(function () {
            let $elOption = $(this).find('.options-select.selected');
            let urlValue = $elOption.val();
            let selectedValueId = $elOption.data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

function getPidValue(itemSubgroupId, size) {
    let sizeValue = $(`.js-size-attribute[data-display-value="${size}"]`).find('.size-value').attr('data-attr-value');
    let pid = itemSubgroupId.replace('-', '|') + '|' + sizeValue;

    return pid;
}

function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

function getChildProducts() {
    let childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    let messageType = response.error ? 'cc-alert--danger' : 'cc-alert--success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        alertMessage(response.message, messageType);
    }
}

function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    let bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    let htmlString = 
          '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            let parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

function attributeSelect(selectedValueUrl, $productContainer, isSizeAttribute = false) {
    return new Promise(function (resolve, reject) {
        if (!selectedValueUrl) {
            reject(new Error('No URL provided'));
            return;
        }

        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer, isSizeAttribute);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);

                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer, isSizeAttribute: isSizeAttribute }
                );

                updateFindInStoreUrl();
                $.spinner().stop();

                resolve(data); // 👈 la promise si risolve con i dati
            },
            error: function (err) {
                $.spinner().stop();
                reject(err); // 👈 la promise si rigetta con l’errore
            }
        });
    });
}


function handleVariantResponse(response, $productContainer, isSizeAttribute = false) {
    let isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    let isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    if (!isSizeAttribute) {
        let primaryImageUrls = response.product.images.large;
        let slideClasses = $($productContainer).find('.js-zoom-image-wrap').attr('class');
        let imgClasses = $($productContainer).find('.js-zoom-image').attr('class');
        createSlickCarousel(primaryImageUrls, $productContainer, slideClasses, imgClasses);
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        let $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);
    $productContainer.find('.js-wishlist-heart').empty().html(response.product.wishlistHeartHtml);
    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        let $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-option').empty().html(optionsHtml);
}

function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        let optionsHtml = quantities.map(function (quantity) {
            let selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

function updateFindInStoreUrl() {
    if ($('#modalFindInStore').length > 0) {
        let iframe = $('#modalFindInStore iframe');
        let iframeSrc = iframe.attr('src');

        // Split the URL into two parts
        let [urlPart1, urlPart2] = iframeSrc.split('value=');
        urlPart1 += 'value='; // Include 'value=' in the first part
        if ($('#product-id-sku').length > 0) {
            urlPart2 = $('#product-id-sku').text();
        }

        iframeSrc = urlPart1 + urlPart2;

        let iframeNew = iframe.clone();
        iframe.remove();
        iframeNew.attr('src', iframeSrc);

        $('#modalFindInStore .js-iframe-wrp').append(iframeNew);
    }
}

function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    let attrsWithSwatches = ['color','size'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        let $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="'
            + attrValue.value + '"]');
        let $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        }

        // Disable if not selectable
        $attrValue.closest('.js-size-attribute').removeClass('cc-available cc-unavailable');
        $attrValue.closest('.js-size-attribute').find('.js-quickview__size-swatch').removeClass('cc-available cc-unavailable');

        $attrValue.closest('.js-size-attribute').addClass(attrValue.selectable ? 'cc-available' : 'cc-unavailable');
        $attrValue.closest('.js-size-attribute').find('.js-quickview__size-swatch').addClass(attrValue.selectable ? 'cc-available' : 'cc-unavailable');
    });
}

function processNonSwatchValues(attr, $productContainer) {
    let $attr = '[data-attr="' + attr.id + '"]';
    let $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        let $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

function createSlickCarousel(imgs, $productContainer, slideClasses, imgClasses) {
    let slickContainer = $productContainer.find('.js-slider');
    if (slickContainer && slickContainer.length){
        $(slickContainer).slick("unslick");
        $(slickContainer).empty();
    }

    for (let i = 0; i < imgs.length; i++) {
        let image = imgs[i];
        let slideDiv = $('<div class="' + slideClasses + '"></div>');
        let productImage = $('<div class="cc-product-image"></div>');
        if (!imgClasses) {
            imgClasses = '';
        }
        let imgElement = $('<img src="' + image.url + '" class="' + imgClasses +'" alt="' + image.alt + ' image number ' + image.index + '" itemprop="image" />');

        imgElement.appendTo(productImage);
        productImage.appendTo(slideDiv);
        slideDiv.appendTo(slickContainer);
    }

    if ($('.js-pdp-slider-img').length > 0) {
        const mainImageNumber = $('.js-pdp-slider-img .cc-pdp__image-wrp').length;
        
        if (mainImageNumber % 2 > 0) {
            $('.js-pdp-slider-img').addClass('cc-pdp__slider--first-big');
        } else {
            $('.js-pdp-slider-img').removeClass('cc-pdp__slider--first-big');
        }
    }

    slickContainer.slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: true,
        responsive: [{
            breakpoint: 1198.98,
            settings: "unslick"
        }]
    });
}

function updateAvailability(response, $productContainer) {
    let availabilityValue = '';
    let availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    let html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}   

function getQuantitySelector($el) {
    let quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        let quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        let quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

module.exports = {
    getOptions: getOptions,
    getPidValue: getPidValue,
    getAddToCartUrl: getAddToCartUrl,
    getQuantitySelected: getQuantitySelected,
    getChildProducts: getChildProducts,
    handlePostCartAdd: handlePostCartAdd,
    chooseBonusProducts: chooseBonusProducts,
    miniCartReportingUrl: miniCartReportingUrl,
    attributeSelect: attributeSelect
};
